app.config(function($translateProvider) {
    $translateProvider.translations('en-gb', {
        PARTNERSHIP: 'Partnership',
        PARTNERSHIPS: 'Partnerships',

        ADD_NEW_PARTNERSHIP: 'Add a new Partnership',

        PARTNERSHIP_ADD: 'Add a new Partnership',
        PARTNERSHIPS_ADD: 'Add Partnerships',
        MODIFY_PARTNERSHIPS: 'Modify Partnerships',
        PARTNERSHIPS_LIST: 'Partnerships',

        DELETE_PARTNERSHIPS: 'Delete Partnerships',
        TO_ALL_ACTIVE_SERVICE_PROVIDERS: 'To all active Service Providers',
        SELECT_SPECIFIC_SERVICE_PROVIDERS: 'Select Specific Service Providers',
        FROM_ALL_UNUSED_SERVICE_PROVIDERS: 'From all unused Service Providers',
        CONTINUE_AND_CHOOSE_SERVICE_PROVIDERS: 'Continue and choose service providers',
        WILL_DELETE_ALL_PARTNERSHIPS_FROM_SITE: 'Confirming this action will delete all partnerships for this Site that have not been used.',
        NO_PARTNERSHIPS_UNUSED_FOUND: 'Unable to delete, no unused partnerships found',

        SERVICE_PROVIDER_PARTNERSHIP_ADD: 'Add a new Partnership',

        PARTNERSHIP_LIST: 'Partnerships',
        PARTNERSHIP_EDIT: 'Edit Partnership',

        PARTNERSHIP_CREATED: 'Partnership Created',
        PARTNERSHIP_UPDATED: 'Partnership Updated',
        PARTNERSHIP_DELETED: 'Partnership Deleted',

        PARTNERSHIP_SURVEYS_ADDED: 'Surveys Added',
        PARTNERSHIP_SURVEYS_DELETED: 'Surveys Deleted',

        PARTNERSHIP_STATUS: 'Partnership Status',

        SURVEYS_ADDED: 'Surveys Added',
        SURVEYS_DELETED: 'Surveys Deleted',

        PARTNERSHIP_IN_USE: 'Partnership in use'
    });
});
